export enum GlobalNotificationError {
	USERS_ERROR = 'There was an error loading users. Please try again.',
	NOTIFICATIONS_ERROR = 'There was an error loading notifications. Please try again.',
}

export enum GlobalNotificationMessage {
	DELETE_MESSAGE = 'Are you sure you want to delete?',
}
